import type { ClientProfileDto } from '@/app/store/api/restApi';

export const resolveProfileOrderEmail = (
  profile: Pick<ClientProfileDto, 'email' | 'verifiedEmail'>,
): string | undefined => profile.email || profile.verifiedEmail || undefined;
